import { RouterProvider } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import router from "./route.js";
import { jwtDecode } from "jwt-decode";
import { ApplicationContext } from "./context/ApplicationContext.js";
import { subscribeUser } from "./utils/subscribeUser.js";
// import ChatBot from "./components/ChatBot.jsx";

function App() {
  const [jwt, setJwt] = useState(() => localStorage.getItem("token"));
  const [loading, setLoading] = useState(true);
  const { setLoggedInUser } = useContext(ApplicationContext);

  useEffect(() => {
    let token = window.JWT_TOKEN;

    const handleJWT = (token) => {
      // console.log('token received is:', token)
      localStorage.setItem("token", token);
      const decoded = jwtDecode(token).data;
      setLoggedInUser(decoded);
      setJwt(token);
      setLoading(false);
    };

    if (!token) {
      window.parent.postMessage({ type: "READY_FOR_JWT" }, "*");

      const allowedBaseDomain = process.env.REACT_APP_JWT_TOKEN_BASE_DOMAIN;

      const listener = (event) => {
        try {
          if (!event.origin) return;

          const originURL = new URL(event.origin);
          const incomingHostname = originURL.hostname;

          // console.log("event.origin:", event.origin);
          // console.log("hostname:", incomingHostname);
          // console.log("ENV domain:", allowedBaseDomain);

          // Check if the hostname is exactly the base domain (e.g., kasturihrms.com)
          // OR is a valid subdomain like *.kasturihrms.com
          const isValid =
            incomingHostname === allowedBaseDomain || // exact match
            incomingHostname.endsWith(`.${allowedBaseDomain}`); // subdomain match

          if (!isValid) {
            console.warn("Invalid origin:", incomingHostname);
            return;
          }

          const { type, token } = event.data;
          if (type === "SET_JWT" && token) {
            handleJWT(token);
          }
        } catch (err) {
          console.error("Error parsing event.origin:", err);
        }
      };

      window.addEventListener("message", listener);
    } else {
      handleJWT(token);
    }
  }, []);




  useEffect(() => {
    subscribeUser();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {/* <ChatBot /> */}
      <RouterProvider router={router} />
      <ToastContainer />
    </>
  );
}
export default App;
